import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRowDiv, FlexRowSpaceBetween } from "./common.styles";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { LightText } from "./HXMobilePage.styles";
import { SemiBoldText } from "./HXDesktopPage.styles";
import Chip from "@mui/material/Chip";
export const InformedConsentExperienceViewParent = styled(FlexColumn) `
    padding-top: 24px;
    gap: 24px;
`;
export const VersionHistorySection = styled(FlexColumnDiv) `
    gap: 24px;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background: ${colors.white_main};
    padding: 24px;
    align-self: stretch;
`;
export const VersionHistoryTitleAndText = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const VersionHistoryTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const VersionHistoryText = styled(LightText) ``;
export const VersionHistoryList = styled(FlexColumnDiv) `
    gap: 24px;
`;
export const VersionHistoryItem = styled(FlexRowSpaceBetween) `
    flex-grow: 1;

    padding: 24px;

    border-radius: 4px;
    border: 1px solid ${({ current }) => (current ? colors.forest_8 : colors.black_12)};
    background: ${({ current }) => (current ? colors.forest_8 : colors.white_main)};
`;
export const PreviewButtons = styled(FlexRowDiv) `
    gap: 8px;
    align-self: center;
`;
export const VersionHistoryItemContent = styled(FlexColumnDiv) `
    gap: 8px;
`;
export const VersionHistoryItemName = styled(SemiBoldText) ``;
export const VersionHistoryItemPublishedDate = styled.div ``;
export const ActiveChip = styled(Chip) `
    background: ${colors.forest_8};
    color: ${colors.forest_main};
    align-self: flex-start;
`;
export const InitialChip = styled(Chip) `
    background: ${colors.black_8};
    color: ${colors.black_main};
    align-self: flex-start;
`;
